export const toggleOptions = {
  headline: 'Headline',
  byline: 'Byline',
  storyText: 'Story text',
  keyword: 'All',
};
